import React, { useState, useEffect, ChangeEvent } from 'react';
import VersionModal from '../../Modals/VersionModal';
import Level1Headers from './Level1Headers';
import Level2Headers from './Level2Headers';
import Level3Headers from './Level3Headers';
import Level1Row from './Level1Row';
import Level2Row from './Level2Row';
import Level3Row from './Level3Row';
import Pagination from '@mui/material/Pagination';
interface IResultsTableProps {
  curVersion: any;
  passedDownResults: any;
  activeFilter: string;
  curLevel: number;
  setCurLevel: any;
  setIsHistoryModalOpen: any;
  handleVisClick: any;
  cur_case: any;
  setShareModal: any;
  setIsCommentsModalOpen: any;
  setIsFrequencyModalOpen: any;
  setIsApprovalModalOpen: any;
  setScreenParamsModal: any;
  handleCSV: any;
  updateFilters: any;
  resetTable: any;
  newTab: boolean;
  setNewTab: any;
  currentPage: number;
  setCurrentPage: any;
  currentItems: any;
  setCurrentItems: any;
}

const ResultsTable: React.FC<IResultsTableProps> = ({ curVersion, passedDownResults, activeFilter, curLevel, setCurLevel, setIsHistoryModalOpen, handleVisClick, cur_case, setShareModal, setIsApprovalModalOpen, setIsCommentsModalOpen, setIsFrequencyModalOpen, setScreenParamsModal, handleCSV, updateFilters, resetTable, newTab, setNewTab, currentPage, setCurrentPage, currentItems, setCurrentItems }) => {
  const [ isOpenVersionModal, setIsOpenVersionModal ] = useState(false);
  const [ selectedResult, setSelectedResult ] = useState<any>({});
  const [ selectedFilteredResults, setSelectedFilteredResults ] = useState([]);
  const [ selectedFilter, setSelectedFilter ] = useState('');
  const [ filteredResArr, setFilteredResArr ] = useState<any>({});
  const [ totalPages, setTotalPages ] = useState(1);
  const [ indexOfFirstItems, setIndexOfFirstItems ] = useState(0);
  const itemsPerPage = 10;

  const handlePageChange = (e: ChangeEvent<unknown>, new_page: number) => {
    setCurrentPage(new_page);
    const indexOfLastItem = new_page * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfFirstItems(indexOfFirstItem);

    if (curLevel === 1) {
      setCurrentItems(passedDownResults.slice(indexOfFirstItem, indexOfLastItem));
    } else if (curLevel === 2) {
      setCurrentItems(filteredResArr.slice(indexOfFirstItem, indexOfLastItem));
    } else {
      setCurrentItems(selectedFilteredResults.slice(indexOfFirstItem, indexOfLastItem));
    }
  };

  const handleVersionCloseModal = () => {
    setIsOpenVersionModal(!isOpenVersionModal);
  };

  const handleHitSelect = (hit: any) => {
    setSelectedResult(hit);
    const newArr = groupByKey(hit.docs, activeFilter);
    setFilteredResArr(newArr);
    setCurLevel(2);
    setCurrentPage(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfFirstItems(indexOfFirstItem);
    setTotalPages(Math.ceil(newArr.length / itemsPerPage));
    setCurrentItems(newArr.slice(indexOfFirstItem, indexOfLastItem));
  };

  const handleFilteredHitSelect = (filteredHit: any, filter: string) => {
    setSelectedFilteredResults(filteredHit);
    setSelectedFilter(filter);
    setCurLevel(3);
    setCurrentPage(1);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    setIndexOfFirstItems(indexOfFirstItem);
    setTotalPages(Math.ceil(filteredHit.length / itemsPerPage));
    setCurrentItems(filteredHit.slice(indexOfFirstItem, indexOfLastItem));
  };

  const groupByKey = (array: any[], key: string) => {
    const groupsMap = array.reduce(
      (acc, obj) => {
        const keyValue = obj[key];
        if (keyValue !== undefined) {
          if (!acc[keyValue]) {
            acc[keyValue] = [];
          }
          acc[keyValue].push(obj);
        } else {
          if (!acc[`No ${key}`]) {
            acc[`No ${key}`] = [];
          }
          acc[`No ${key}`].push(obj);
        }
        return acc;
      },
      { }
    );

    // Convert the groupsMap object into an array of objects
    const result = Object.entries(groupsMap).map(([ groupKey, items ]) => ({
      key: groupKey,
      items: items,
    }));
    return result;
  };

  const handleVisClick2 = (index: number) => {
    const actualIndex = indexOfFirstItems + index;
    if (filteredResArr.length === 1){
      setCurLevel(1);
    }else if (currentPage > 1) {
      const updatedResults = filteredResArr.filter((res: any, i: number) => i !== actualIndex);
      setFilteredResArr(updatedResults);
      if (currentItems.length <= 1) {
        setCurrentPage(currentPage - 1);
      }
    } else {
      const updatedResults = filteredResArr.filter((res: any, i: number) => i !== index);
      setFilteredResArr(updatedResults);
    }
  };

  const handleVisClick3 = (index: number) => {
    const actualIndex = indexOfFirstItems + index;
    if (selectedFilteredResults.length === 1){
      setCurLevel(2);
    } else if (currentPage > 1){
      const updatedResults = selectedFilteredResults.filter((res: any, i: number) => i !== actualIndex);
      setSelectedFilteredResults(updatedResults);
      if (currentItems.length <= 1) {
        setCurrentPage(currentPage - 1);
      }
    } else {
      const updatedResults = selectedFilteredResults.filter((res: any, i: number) => i !== index);
      setSelectedFilteredResults(updatedResults);
    }
  };

  const sumHits = (objects: any[]): number => {
    return objects.reduce((total, obj) => total + (obj.hits || 0), 0);
  };

  const handleSearchChange = (e: any) => {
    const searchValue = e.target.value;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    if (curLevel === 1) {
      if (passedDownResults.length > 0) {
        const results = passedDownResults.filter((item: ArrayLike<unknown> | { [s: string]: unknown; }) =>
          Object.values(item).some(
            (value) =>
              typeof value === 'string' &&
              value.toLowerCase().includes(searchValue.toLowerCase())
          )
        );
        setCurrentItems(results.slice(indexOfFirstItem, indexOfLastItem));
        setTotalPages(Math.ceil(results.length / itemsPerPage));
      }
    } else if (curLevel === 2) {
      const results = filteredResArr.filter((item: ArrayLike<unknown> | { [s: string]: unknown; }) =>
        Object.values(item).some(
          (value) =>
            typeof value === 'string' &&
            value.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
      setCurrentItems(results.slice(indexOfFirstItem, indexOfLastItem));
      setTotalPages(Math.ceil(results.length / itemsPerPage));
    } else {
      const results = selectedFilteredResults.filter((item: ArrayLike<unknown> | { [s: string]: unknown; }) =>
        Object.values(item).some(
          (value) =>
            typeof value === 'string' &&
            value.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
      setCurrentItems(results.slice(indexOfFirstItem, indexOfLastItem));
      setTotalPages(Math.ceil(results.length / itemsPerPage));
    }
  };

  useEffect(() => {
    if (curLevel === 1) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      if (passedDownResults.length > 0) {
        setCurrentItems(passedDownResults.slice(indexOfFirstItem, indexOfLastItem));
        setTotalPages(Math.ceil(passedDownResults.length / itemsPerPage));
        setIndexOfFirstItems(indexOfFirstItem);
      } else {
        setTotalPages(1);
      }
    } else if (curLevel === 2) {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      setTotalPages(Math.ceil(filteredResArr.length / itemsPerPage));
      setCurrentItems(filteredResArr.slice(indexOfFirstItem, indexOfLastItem));
      setIndexOfFirstItems(indexOfFirstItem);
      setIndexOfFirstItems(indexOfFirstItem);
    } else {
      const indexOfLastItem = currentPage * itemsPerPage;
      const indexOfFirstItem = indexOfLastItem - itemsPerPage;
      setTotalPages(Math.ceil(selectedFilteredResults.length / itemsPerPage));
      setCurrentItems(selectedFilteredResults.slice(indexOfFirstItem, indexOfLastItem));
      setIndexOfFirstItems(indexOfFirstItem);
    }
  }, [ passedDownResults, filteredResArr, selectedFilteredResults, curLevel ]);

  return (
    <>
      <div className='results-table-frame'>
        <div className='results-table-frame-headers'>
          <div className='results-table-frame-headers-left'>

            <div className='results-table-frame-headers-left-all' onClick={() => {
              setCurLevel(1);
              setCurrentPage(1);
            }}>
              <div className='results-table-frame-headers-left-all-crumb'>All</div>
            </div>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
            </svg>
            {curLevel >= 2 &&
             <>
               <div className='results-table-frame-headers-left-all' onClick={() => {
                 setCurLevel(2);
                 setCurrentPage(1);
               }}>
                 <div className='results-table-frame-headers-left-all-crumb'>{selectedResult.field}</div>
               </div>
               <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                 <path d='M6 12L10 8L6 4' stroke='#D0D5DD' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
               </svg>
             </>
            }
            {curLevel >= 3 &&
               <div className='results-table-frame-headers-left-all'>
                 <div className='results-table-frame-headers-left-all-crumb'>{selectedFilter}</div>
               </div>
            }
          </div>
          <div className='results-table-frame-headers-right'>
            <div className='results-table-reset-btn' onClick={updateFilters}>Save Current Filters</div>
            <div className='results-table-reset-btn' onClick={resetTable}>Reset Table</div>
            <div className='results-table-frame-headers-right-version'>Version: {curVersion ? curVersion.date : 'N/A'}</div>
            <div className='results-table-frame-headers-right-change' onClick={() => setIsHistoryModalOpen(true)}>Change </div>
          </div>
        </div>
        <div className='results-table-frame-tables'>
          <div className='results-table-frame-tables-table'>
            <div className='results-table-frame-tables-table-content'>
              {newTab ? <div className='results-table-frame-tables-table-content-hor'>
                <div className='results-table-frame-tables-table-content-hor-detail' onClick={() => setNewTab(false)} style={{ cursor: 'pointer' }}>
                  <div className='results-table-frame-tables-table-content-hor-detail-text' >All</div>
                </div>
                <div
                  className='results-table-frame-tables-table-content-hor-all' >
                  <div
                    className='results-table-frame-tables-table-content-hor-all-text'>New</div>
                  {(curVersion && curVersion.newTotal > 0) && <div className='new-results-tag-monitor'>{curVersion.newTotal}</div>}
                </div>
              </div> : <div className='results-table-frame-tables-table-content-hor'>
                <div className='results-table-frame-tables-table-content-hor-all'>
                  <div className='results-table-frame-tables-table-content-hor-all-text'>All</div>
                </div>
                <div className='results-table-frame-tables-table-content-hor-detail' onClick={() => setNewTab(true)} style={{ cursor: 'pointer' }}>
                  <div className='results-table-frame-tables-table-content-hor-detail-text'>New</div>
                  {(curVersion && curVersion.newTotal > 0) && <div className='new-results-tag-monitor'>{curVersion.newTotal}</div>}
                </div>
              </div>}
              <div className='monitor-table-results-display'>
                Results: {passedDownResults.length > 0 ? sumHits(passedDownResults) : '0'}</div>
              <div className='results-table-frame-tables-table-content-search'>
                <div className='tabs-filters-input-dropdown' >
                  <div style={{ maxHeight: '40px' }}>
                    <div className='input-icon-container' style={{ top: '12px' }}>
                      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                        <path id='Icon' d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
                      </svg>
                    </div>
                    <input className='tabs-filters-input' placeholder='Search results' style={{ maxHeight: '40px' }} onChange={(e) => handleSearchChange(e)} />
                  </div>
                </div>
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none' cursor={'pointer'} onClick={handleVersionCloseModal}>
                  <path d='M2.25 9.5H15.75M2.25 5H15.75M6.75 14H15.75' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </div>
            </div>
            {Object.keys(passedDownResults).length === 0 ?
              (
                <div className='view-history-head-frame-table'>
                  <Level1Headers />
                  <div className='view-history-body-frame' style={{ height: '450px', maxHeight: '450px' }}>
                    <p>No Results for this Ticket</p>
                  </div>
                </div>
              ) : (curLevel === 1 ? (
                <div className='view-history-head-frame-table'>
                  <Level1Headers />
                  <div className='view-history-body-frame' style={{ height: '450px', maxHeight: '450px' }}>
                    {currentItems.map((row: any, index: number) => (
                      <Level1Row
                        key={index}
                        index={indexOfFirstItems + index}
                        result={row}
                        handleHitSelect={handleHitSelect}
                        handleVisClick={handleVisClick}
                      />
                    ))}
                  </div>
                </div>
              ) : (
                curLevel === 2 ? (
                  <div className='view-history-head-frame-table'>
                    <Level2Headers
                      filter={activeFilter}
                    />
                    <div className='view-history-body-frame' style={{ height: '450px', maxHeight: '450px' }}>
                      {currentItems.map((row: any, index: number) => (
                        <Level2Row
                          key={index}
                          index={index}
                          results={row.items}
                          name={row.key}
                          handleHitSelect={handleFilteredHitSelect}
                          handleVisClick={handleVisClick2}
                        />
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className='view-history-head-frame-table'>
                    <Level3Headers />
                    <div className='view-history-body-frame' style={{ height: '450px', maxHeight: '450px' }}>
                      {currentItems.map((row: any, index: number) => (
                        <Level3Row
                          key={index}
                          index={index}
                          result={row}
                          selected={selectedResult.field}
                          handleVisClick={handleVisClick3}
                        />
                      ))}
                    </div>
                  </div>
                )

              ))
            }
            <div className='monitor-results-footer'>
              <div className='screening-results-pagination-text'>
                     Page {currentPage} of {totalPages}
              </div>
              <div className='screening-results-footer-action-group'>
                <div className='hb-pagination'>
                  <Pagination
                    onChange={handlePageChange}
                    size='large'
                    count={totalPages}
                    shape='rounded'
                    variant='text'
                    page={currentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {
          isOpenVersionModal && (
            <VersionModal
              cur_case={cur_case}
              setShareModal={setShareModal}
              setIsCommentsModalOpen={setIsCommentsModalOpen}
              setIsFrequencyModalOpen={setIsFrequencyModalOpen}
              setIsApprovalModalOpen={setIsApprovalModalOpen}
              setIsHistoryModalOpen={setIsHistoryModalOpen}
              setScreenParamsModal={setScreenParamsModal}
              handleCSV={handleCSV}
            />
          )
        }
      </div>

    </>
  );
};

export default ResultsTable;
